export const PRODUCT_NAME = "Maximo Evidence Refinery";
